import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  page: {
    display: "flex",
    justifyContent: "center",
  },
  emailContainer: {
    padding: theme.spacing(3),
    width: "600px",
    height: "100%",
    background: theme.palette.emailBackground.main,
  },
  logosContainer: {
    display: "flex",
    justifyContent: "center",
    paddingBottom: theme.spacing(3),
  },
  emailBody: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(2),
    gap: theme.spacing(2),
    border: `1px solid ${theme.palette.warning.main}`,
    borderRadius: theme.spacing(1),
  },
  taskItem: {
    padding: theme.spacing(3),
    background: "rgba(255, 152, 0, 0.08)",
    color: theme.palette.contrastEmailText.main,
    borderRadius: theme.spacing(1),
    width: "100%",
    textAlign: "center",
  },
  logo: {
    width: 80,
    height: 80,
    border: "1px solid #E0E0E0",
    borderRadius: theme.spacing(1),
    "& + &": {
      marginLeft: theme.spacing(2),
    },
  },
  greeting: {
    width: "100%",
    color: theme.palette.contrastText.main,
    fontSize: theme.spacing(3),
    fontWeight: 500,
    textAlign: "center",
    marginBottom: theme.spacing(3),
  },
  poweredByContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(45),
  },
  emailText: {
    textAlign: "center",
    color: theme.palette.warning.main,
  },
  submitButton: {
    display: "flex",
    margin: "0 auto",
    padding: theme.spacing(1, 2),
    flex: "0 1 auto",
    height: 40,
    textAlign: "center",
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: theme.spacing(2.5),
    textTransform: "uppercase",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 600,
    marginTop: theme.spacing(3),
  },
}));
